export const DsPaginationOverrides = {};
